import { FC } from 'react';
import { Box, Container, Grid, makeStyles, Theme } from '@material-ui/core';
import { useMediaUp } from 'hooks';
import { macbookImage } from 'images/retail-energy';
import clsx from 'clsx';

export interface VideoHeaderProps {
  className?: string;
  imageSrcset?: string;
  videoSrcset: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    position: 'relative',
  },
  imgWrapper: {
    width: '100%',
    zIndex: 1,
    position: 'relative',
    maxHeight: 580,
    [theme.breakpoints.up('md')]: {
      maxHeight: 498,
    },
    [theme.breakpoints.up('lg')]: {
      objectFit: 'fill',
      maxHeight: 580,
    },
  },
  videoWrapper: {
    position: 'absolute',
    zIndex: 0,
    maxWidth: '77%',
    left: '11%',
    top: '4%',
    objectFit: 'cover',
    minHeight: 200,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 'calc(100% - 130px)',
      left: 60,
      top: 15,
      minHeight: 300,
    },
    [theme.breakpoints.up('md')]: {
      top: 26,
      left: 115,
      maxWidth: 703,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 809,
      top: 33,
      left: 115,
    },
  },
  singleVideo: {
    width: '100%',
  },
}));

const VideoHeader: FC<VideoHeaderProps> = ({ className, imageSrcset, videoSrcset }) => {
  const classes = useStyles();
  const isMediumUp = useMediaUp('sm');

  return (
    <Box className={className}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={6} justifyContent="center">
          <Grid lg={10} xs={12} item>
            <div className={classes.wrapper}>
              <img src={macbookImage} className={classes.imgWrapper} alt="macbook wrapper" />
              {imageSrcset ? (
                <>
                  {isMediumUp ? (
                    <video className={classes.videoWrapper} autoPlay muted loop>
                      <source src={videoSrcset} type="video/mp4" />
                      This browser does not support the HTML5 video element.
                    </video>
                  ) : (
                    <img className={classes.videoWrapper} src={imageSrcset} alt="Video Instruction" />
                  )}
                </>
              ) : (
                <video className={clsx(classes.videoWrapper, classes.singleVideo)} autoPlay muted loop>
                  <source src={videoSrcset} type="video/mp4" />
                  This browser does not support the HTML5 video element.
                </video>
              )}
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default VideoHeader;
